// System / Light / Dark, as three small icon buttons with styled tooltips.
import { useState } from "preact/hooks";
import { Monitor, Moon, Sun } from "lucide-preact";
import { setTheme, themeChoice, type ThemeChoice } from "../lib/theme";
import { t } from "../i18n";

const OPTIONS: [ThemeChoice, typeof Sun][] = [
  ["system", Monitor],
  ["light", Sun],
  ["dark", Moon],
];

export function ThemeSwitch() {
  const [choice, setChoice] = useState<ThemeChoice>(themeChoice);
  return (
    <div class="theme-switch" role="radiogroup" aria-label={t("theme.label")}>
      {OPTIONS.map(([v, Icon]) => (
        <button
          key={v}
          type="button"
          role="radio"
          aria-checked={choice === v}
          aria-label={t(`theme.${v}`)}
          data-tip={t(`theme.${v}`)}
          onClick={() => {
            setTheme(v);
            setChoice(v);
          }}
        >
          <Icon size={16} strokeWidth={1.75} aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
